/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulesetid2Inputs */

const en_entity_rulesetid2 = /** @type {(inputs: Entity_Rulesetid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Set ID`)
};

const de_entity_rulesetid2 = /** @type {(inputs: Entity_Rulesetid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Rule Set ID" |
*
* @param {Entity_Rulesetid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulesetid2 = /** @type {((inputs?: Entity_Rulesetid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulesetid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulesetid2(inputs)
	return de_entity_rulesetid2(inputs)
});
export { entity_rulesetid2 as "entity_ruleSetId" }